<template>
  <div class="upload-icon" @click="togglePopup" :style="{ width: size + 'px', height: size + 'px' }">
    <svg class="progress-ring" :width="size" :height="size">
      <!-- Outer ring: overall progress -->
      <circle
        class="progress-ring__circle overall"
        :stroke="overallColor"
        :stroke-width="ringStroke"
        stroke-linecap="round"
        fill="transparent"
        :r="outerRadius"
        :cx="center"
        :cy="center"
        :style="{ strokeDasharray: outerCircumference, strokeDashoffset: outerOffset }"
      />
      <!-- Inner ring: current upload progress -->
      <circle
        class="progress-ring__circle current"
        :stroke="currentColor"
        :stroke-width="ringStroke"
        stroke-linecap="round"
        fill="transparent"
        :r="innerRadius"
        :cx="center"
        :cy="center"
        :style="{ strokeDasharray: innerCircumference, strokeDashoffset: innerOffset }"
      />
    </svg>
    <v-icon :small="size <= 24" class="icon-label" :style="{ fontSize: cloudFontSize + 'px' }">mdi-cloud-upload</v-icon>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'UploadIcon',
  props: {
    size: { type: Number, default: 40 },
    overallColor: { type: String, default: '#1976D2' },
    currentColor: { type: String, default: '#42A5F5' },
    outer: { type: Number, default: null },
    inner: { type: Number, default: null },
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters('upload', ['overallProgress', 'currentProgress']),
    center() {
      return this.size / 2
    },
    ringStroke() {
      return this.size < 28 ? 2 : 3
    },
    outerRadius() {
      if (this.outer) return this.outer
      return Math.max(0, (this.size / 2) - this.ringStroke)
    },
    innerRadius() {
      if (this.inner) return this.inner
      const gapBetween = this.size <= 24 ? 2 : Math.max(3, Math.round(this.size / 10))
      const innerGapAdjust = 4
      const candidate = this.outerRadius - Math.max(1, gapBetween - innerGapAdjust) - 1
      return Math.max(0, candidate)
    },
    cloudFontSize() {
      // Keep cloud small enough not to cover the inner ring
      return Math.max(10, Math.floor(this.size * 0.45))
    },
    outerCircumference() {
      return 2 * Math.PI * this.outerRadius;
    },
    innerCircumference() {
      return 2 * Math.PI * this.innerRadius;
    },
    outerOffset() {
      return this.outerCircumference - (this.overallProgress / 100) * this.outerCircumference;
    },
    innerOffset() {
      return this.innerCircumference - (this.currentProgress / 100) * this.innerCircumference;
    },
  },
  methods: {
    togglePopup() {
      this.$emit('toggle');
    }
  }
};
</script>

<style scoped>
.upload-icon {
  position: relative;
  width: 40px;
  height: 40px;
  cursor: pointer;
}

.progress-ring {
  transform: rotate(-90deg);
}

.progress-ring__circle {
  transition: stroke-dashoffset 0.35s;
  transform: rotate(-90deg);
  transform-origin: 50% 50%;
}

.icon-label {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-size: 16px;
}
</style>
